import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyCheckboxModule } from '@vendasta/galaxy/checkbox';
import { GalaxyInputModule } from '@vendasta/galaxy/input';
import { GalaxyPopoverModule } from '@vendasta/galaxy/popover';
import { GalaxySnackbarModule } from '@vendasta/galaxy/snackbar-service';
import { VaBreadcrumbsModule, VaMaterialTableModule } from '@vendasta/uikit';
import {
  Filter2TableModule,
  TABLE_DEFINITION,
  VaFilteredMatTableService,
  VaTableSortService,
} from '@vendasta/va-filter2-table';
import baseTranslation from '../../assets/i18n/en_devel.json';
import { PageComponent } from '../common/page.component';
import { VBoxComponent } from '../common/vbox';
import { WEBLATE_COMPONENT_NAME } from '../constants';
import { FacebookIntegrationStepperComponent } from './connection-stepper/facebook-integration-stepper.component';
import { FacebookIntegrationStepperService } from './connection-stepper/facebook-integration-stepper.service';
import { DisconnectDialogBoxComponent } from './disconnect-dialog-box/disconnect-dialog-box.component';
import { FacebookAdLeadsComponent } from './facebook-ad-leads.component';
import { FacebookAdLeadsService } from './facebook-ad-leads.service';
import { FacebookFormsTableService } from './facebook-forms-table/facebook-forms-table.service';
import { FacebookLeadAdsFormAutomationConfigurationService } from './facebook-forms-table/fb-forms-automation-configuration.service';
import { ConnectedCellComponent } from './facebook-forms-table/fb-forms-table-custom-cells/connected-cell/connected-cell.component';
import { MarketDropDownCellComponent } from './facebook-forms-table/fb-forms-table-custom-cells/market-dropdown-cell/market-dropdown.component';
import { MarketDropdownService } from './facebook-forms-table/fb-forms-table-custom-cells/market-dropdown-cell/market-dropdown.service';
import { FacebookFormsTableFilterService } from './facebook-forms-table/fb-forms-table-filter-service';
import { tableDefinitionFactory } from './facebook-forms-table/fb-forms-table-model';
import { FacebookFormsTableComponent } from './facebook-forms-table/fb-forms-table.component';
import { FacebookPagePickerComponent } from './facebook-pages/facebook-page-picker.component';
import { FacebookPagePickerService } from './facebook-pages/facebook-page-picker.service';
import { FacebookPagePickerPermissionsCellComponent } from './facebook-pages/permissions-cell.component';
import { LeadQualificationSettingsComponent } from './lead-qualification-settings/lead-qualification-settings.component';
import { LeadQualificationSettingsService } from './lead-qualification-settings/lead-qualification-settings.service';
import { LeadsDuplicateDetectionService } from './leads-duplicate-detection.service';
import { FacebookSettingsPageComponent } from './settings/facebook-settings-page.component';
import { FacebookSettingsComponent } from './settings/facebook-settings.component';
import { GalaxyPageModule } from '@vendasta/galaxy/page';

export const FacebookRoutes = {
  ROOT: 'facebook-ad-leads',
  LEAD_ADS: {
    MANAGE: 'manage',
    SETTINGS: 'settings',
  },
  CONNECT: 'connect',
};

@NgModule({
  declarations: [
    FacebookAdLeadsComponent,
    FacebookSettingsPageComponent,
    FacebookPagePickerComponent,
    FacebookIntegrationStepperComponent,
    FacebookSettingsComponent,
    FacebookFormsTableComponent,
    ConnectedCellComponent,
    MarketDropDownCellComponent,
    LeadQualificationSettingsComponent,
    FacebookPagePickerPermissionsCellComponent,
    DisconnectDialogBoxComponent,
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTooltipModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatTableModule,
    FormsModule,
    MatStepperModule,
    MatSelectModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    GalaxyAlertModule,
    GalaxyCheckboxModule,
    GalaxyInputModule,
    GalaxyPopoverModule,
    OverlayModule,
    VaMaterialTableModule,
    Filter2TableModule,
    VaBreadcrumbsModule,
    MatDialogModule,
    GalaxySnackbarModule,

    RouterModule.forChild([
      { path: '', component: FacebookAdLeadsComponent },
      {
        path: FacebookRoutes.LEAD_ADS.SETTINGS,
        component: FacebookSettingsPageComponent,
      },
      {
        path: FacebookRoutes.CONNECT,
        component: FacebookIntegrationStepperComponent,
      },
    ]),
    PageComponent,
    VBoxComponent,
    GalaxyPageModule,
  ],
  exports: [FacebookAdLeadsComponent],
  providers: [
    FacebookAdLeadsService,
    LeadQualificationSettingsService,
    LeadsDuplicateDetectionService,
    FacebookPagePickerService,
    FacebookIntegrationStepperService,
    FacebookLeadAdsFormAutomationConfigurationService,
    MarketDropdownService,
    {
      provide: 'markets$',
      useExisting: 'USER_ACCESSIBLE_MARKETS',
    },
    VaFilteredMatTableService,
    VaTableSortService,
    FacebookFormsTableFilterService,
    FacebookFormsTableService,
    {
      provide: TABLE_DEFINITION,
      useFactory: tableDefinitionFactory,
      deps: [FacebookFormsTableFilterService],
    },
  ],
})
export class FacebookAdLeadsModule {}
